import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import NumberFormat from 'react-number-format';
import {useFormik} from 'formik';
import * as Yup from 'yup';

import AlertDialog from '../../components/alert-dialog/AlertDialog';
import * as RestService from '../../services/eisRest';






  const WorkPositionModal = (props) => {

   

    const [t] = useTranslation();      
    const [isOpen, setIsOpen] = useState(false);
    const [workPosition, setWorkPosition] = React.useState([]); 
    const [openAlertDialog, setOpenAlertDialog] = React.useState(false);
    const [avgCostPerHour, setAvgCostPerHour] = React.useState(0); 
    
  
  
    const hideModal = () => {
      setIsOpen(false);
      showChanged(false);
    };

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus);
    }
    
    const deleteRecord = () => {
      setOpenAlertDialog(true);
    };


    const handleChange = (e,elementName) => {
      
      if(workPosition!=null){
          switch(elementName){            
              case "avgCostPerHour":           
                workPosition.avgCostPerHour=e.floatValue;    //number    
                setAvgCostPerHour(e.floatValue);                
              break;  
          
               default:            
              
          }          
      }
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    
        positionCode:  workPosition ? workPosition.positionCode : "",
        positionName: workPosition ? workPosition.positionName : ""
     //   avgCostPerHour: workPosition ? workPosition.avgCostPerHour : 0
      },
      validationSchema: Yup.object({
        positionCode: Yup.string()     
          .required(t('general.message.required')),
          positionName: Yup.string()     
          .required(t('general.message.required'))
          
      }),
      onSubmit: (values) => {           
          save('user/saveWorkPosition',values);         
      }
    });

    useEffect(() => {
    //  formik.resetForm();
      setIsOpen(props.modal);
      showChanged(props.modal);

    }, [props.modal])

    useEffect(() => {      
      RestService.callAnyApi('user/getWorkPosition?id='+props.selectedRecord, null)
      .then((data) => {
           setWorkPosition(data);})
      .catch((error) => {
        console.log(error);
      });

    }, [props.selectedRecord])

  
  
   

    const handleAlertDialogCallback = (clickedValue) => {
      setOpenAlertDialog(false);
      if(clickedValue==='OK'){
        RestService.callAnyApi('basic/deleteRecord?entity=workPosition&id='+props.selectedRecord, null).then(
          (data) => {
            if(data.message==='OK'){
              hideModal();
            }else{
              showError(null,data.message);
          }
          })
          .catch((error) => {
            toast.error(error);
          });
      }
       
    }
  
    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
         
      workPosition.positionCode=values.positionCode;
      workPosition.positionName=values.positionName;
      workPosition.avgCostPerHour = avgCostPerHour;

      RestService.callAnyApi(url, workPosition)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));                                              
                          hideModal();
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

 


    return (
      <>    
       <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    //size="lg"                  
                  >
                    <form onSubmit={formik.handleSubmit}>     
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('user.label.workPosition')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
  
                            <div clasName="row">
                                <div className="col-12">
                                  <div className="form-group">
                                    <label>{t('user.label.positionCode')}</label>
                                    <input type="text" className="form-control" placeholder="" {...formik.getFieldProps('positionCode')} />
                                  </div>
                                  {formik.touched.positionCode && formik.errors.positionCode ? (<div style={{ color: 'red' }}>{formik.errors.positionCode}</div>) : null} 
                                </div>    
                            </div>

                            <div clasName="row">
                                <div className="col-12">
                                  <div className="form-group">
                                    <label>{t('user.label.positionName')}</label>
                                    <input type="text" className="form-control" placeholder="" {...formik.getFieldProps('positionName')} />
                                  </div>
                                  {formik.touched.positionName && formik.errors.positionName ? (<div style={{ color: 'red' }}>{formik.errors.positionName}</div>) : null} 
                                </div> 
                            </div>

                            <div clasName="row">
                                <div className="col-5 col-sm-5 col-lg-5">
                             
                                <NumberFormat displayType="input"  className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="3" thousandSeparator="." decimalSeparator="," suffix={' €'} value={workPosition ? workPosition.avgCostPerHour : 0}  onValueChange={(values)  => {handleChange(values,"avgCostPerHour")}} />                                                
                                </div>
                            </div>

                    </Modal.Body>
                    <Modal.Footer>                          
                          <Button style={props.selectedRecord!='' ? {} : { display: 'none' }} className="btn-danger" onClick={deleteRecord}>{t('general.button.delete')}</Button>    
                          <Button className="btn-primary" type="submit">{t('general.button.save')}</Button>    
                          <Button className="btn-default" onClick={hideModal}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                    </form>  
                                        
                  </Modal>                                      
                </div>
               
                <AlertDialog
                open={openAlertDialog}
                message={t('general.message.areYouSure')}
                header={t('general.message.confirmDelete')}
                parentCallback={handleAlertDialogCallback}
                ></AlertDialog> 
      </>
    );
  };

 export default WorkPositionModal;